import React, { memo } from "react";
import PropTypes from "prop-types";

const Anchor = memo(({ children, href, className = "", ...otherProps }) => {
  if (href)
    otherProps = {
      ...otherProps,
      onClick: () => {}
    };
  className = "pointer ".concat(className);
  return (
    <a {...otherProps} href={href} className={className}>
      {children}
    </a>
  );
});

Anchor.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

export default Anchor;



// WEBPACK FOOTER //
// ./src/components/ui-ant/Anchor/index.js